import type { Interaction } from './protocol';
import type { Clip, InteractionBundle } from './asset-contract';

export interface SocialPlayback { kind: 'sit' | 'wave' | 'authored'; elapsed: number; seatHeight: number; key?: string; clip?: Clip; gesture?: boolean; blendIn?: number; blendOut?: number }

// All roles use exactly the same server time and start. Preparing and future
// starts hold at zero; a new generation never continues an old local clock.
export function socialPlayback(items: readonly Interaction[], entityId: string, serverMS: number, bundle: (id: string) => InteractionBundle | undefined = () => undefined): SocialPlayback | null {
  for (const i of items) {
    const role = i.roles.find(r => r.entityId === entityId);
    if (role && i.phase !== 'invited') return { kind: i.assetId === 'builtin_sit_v1' ? 'sit' : i.assetId === 'builtin_pair_wave_v1' ? 'wave' : 'authored', elapsed: i.phase === 'active' ? Math.max(0, (serverMS - i.startMs) / 1000) : 0, seatHeight: role.seatHeight, key: `${i.id}:${i.generation}`, clip: bundle(i.id)?.clips[i.roles.indexOf(role)], gesture: i.kind === 'gesture', blendIn: i.playback.blendIn, blendOut: i.playback.blendOut };
  }
  return null;
}
